import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { device } from "../../utils/breakpoints";
import ReactMarkdown from "react-markdown";
import { colors, styles } from "../../utils/theme";
import { BackgroundElement } from "../../styles/SharedStyles";

const CategoryFull = ({ category }) => {
  const [data, setData] = useState(null);
  const { i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    try {
      let dataFile = require(`./../../data/category/category-${category}.json`);
      setData(dataFile);
    } catch (err) {
      let dataFile = require(`./../../data/category/category-generic.json`);
      setData(dataFile);
    }
  }, [category]);

  if (!!data && data[lang] && !!data[lang].description_long) {
    return (
      <Wrapper>
        <LeavesBgElement src={"/assets/img/styling/herb-8.webp"} alt={""} />
        <SeasoningBgElement
          src={"/assets/img/styling/herbs-and-spices-2.webp"}
          alt={""}
        />
        <Container>
          <article>
            <Title>{data[lang].title}</Title>
            <StyledMarkdown>{data[lang].description_long}</StyledMarkdown>
          </article>
        </Container>
      </Wrapper>
    );
  } else return null;
};

const Wrapper = styled.section`
  position: relative;
  overflow-x: hidden;
  overflow-x: clip;
  padding-block: ${styles.banner_padding_mobile};

  @media ${device.lg} {
    padding-block: ${styles.banner_padding_desktop};
  }
`;

const StyledMarkdown = styled(ReactMarkdown)`
  color: ${colors.text};
  line-height: 1.5;

  p,
  li {
    font-size: 14px;
  }

  p:not(:last-of-type) {
    margin-bottom: 2rem;
  }

  h3 {
    font-size: 21px;
    line-height: 1;

    @media ${device.lg} {
      font-size: 24px;
    }
  }

  a {
    color: ${colors.primary};

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Title = styled.h2`
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;

  @media only screen and ${device.lg} {
    font-size: 36px;
    line-height: 38px;
  }
`;

const LeavesBgElement = styled(BackgroundElement)`
  display: none;

  @media ${device.xxl} {
    display: block;
    top: -64px;
    width: 230px;
    left: -90px;
  }
`;

const SeasoningBgElement = styled(BackgroundElement)`
  display: none;
  transform: rotate(90deg);

  @media ${device.xxl} {
    display: block;
    width: 400px;
    bottom: 0;
    right: -300px;
  }
`;

export default CategoryFull;
